const distance = {
    distanceMode: "none",
    referenceLatitude: null,
    referenceLongitude: null,

    //基準位置情報取得の通知
    //これはGPSが初期化したら呼び出される。
    initReferencePosition: function () {
        distance.setHome();

        // GPSフラグがONのときは強制。
        if (
            distance.referenceLatitude === null ||
            distance.referenceLongitude === null ||
            $(".js-parentUserInfo").data("gps")
        ) {
            distance.setGps();
        }

        //完了したら地図にコールバック
        if ($(".js-map-page").length !== 0) {
            nurseryMap.initReferencePosition();
        }

        if (typeof distance.callback === "function") {
            distance.callback();
        }
    },

    setHome: function () {
        if ($(".js-parentUserInfo").length !== 0) {
            //自宅確認。ログインしているから情報があるかもしれない
            if ($(".js-parentUserInfo").data("latitude") !== "" && $(".js-parentUserInfo").data("longitude") !== "") {
                distance.referenceLatitude = $(".js-parentUserInfo").data("latitude");
                distance.referenceLongitude = $(".js-parentUserInfo").data("longitude");
                distance.distanceMode = "home";
            }
        }
    },
    setGps: function () {
        // 自宅情報が取れないなら、自分の位置を取得
        // ここまで来て位置が取れないなら、基準位置は設定しない。
        distance.referenceLatitude = gps.centerLatitude;
        distance.referenceLongitude = gps.centerLongitude;
        distance.distanceMode = "current";
    },

    // 距離情報を計算
    getDistance: function (latitudeTo, longitudeTo) {
        if (!distance.referenceLatitude) {
            return "距離が計算できません";
        }

        const getDistance = distance.calcDistance(
            distance.referenceLatitude.toFixed(3),
            distance.referenceLongitude.toFixed(3),
            latitudeTo,
            longitudeTo
        );
        if (getDistance === "" || distance.referenceLatitude === null || distance.referenceLongitude === null) {
            return "距離が計算できません";
        }

        // 戻り地
        let label = "現在位置から";
        if (distance.distanceMode === "home") {
            label = "自宅から";
        }
        return label + getDistance.toLocaleString() + "M";
    },
    // 距離情報を計算
    calcDistance: function (latitudeFrom, longitudeFrom, latitudeTo, longitudeTo) {
        if (latitudeFrom === null || longitudeFrom === null || latitudeTo === null || longitudeTo === null) {
            // 何も入っていなければ何も計算しない
            return "距離が計算できません";
        }

        // 測地系定数
        // GRS80 ( 世界測地系 ) <- 現在の日本での標準
        const RX = 6378137.0; // 赤道半径
        const RY = 6356752.31414; // 極半径

        // 2点の経度の差を計算 ( ラジアン )
        var a_x = (longitudeFrom * Math.PI) / 180 - (longitudeTo * Math.PI) / 180;

        // 2点の緯度の差を計算 ( ラジアン )
        var a_y = (latitudeFrom * Math.PI) / 180 - (latitudeTo * Math.PI) / 180;

        // 2点の緯度の平均を計算
        var p = ((latitudeFrom * Math.PI) / 180 + (latitudeTo * Math.PI) / 180) / 2;

        // 離心率を計算
        var e = Math.sqrt((RX * RX - RY * RY) / (RX * RX));

        // 子午線・卯酉線曲率半径の分母Wを計算
        var w = Math.sqrt(1 - e * e * Math.sin(p) * Math.sin(p));

        // 子午線曲率半径を計算
        var m = (RX * (1 - e * e)) / (w * w * w);

        // 卯酉線曲率半径を計算
        var n = RX / w;

        // 距離を計算
        var d = Math.pow(a_y * m, 2) + Math.pow(a_x * n * Math.cos(p), 2);
        d = Math.round(Math.sqrt(d));

        return d;
    },
    meterToLatitude: function (centerLatitude, meter) {
        latitudeDegree = (360 * meter) / (2 * Math.PI * 6356752.314);

        northEastLatitude = centerLatitude + latitudeDegree;
        southWestLatitude = centerLatitude - latitudeDegree;

        returnList = {
            northEastLatitude: northEastLatitude,
            southWestLatitude: southWestLatitude
        };

        return returnList;
    },
    meterToLongitude: function (centerLongitude, meter) {
        longitudeDegree = (360 * meter) / (2 * Math.PI * (6378137 * Math.cos((35 * Math.PI) / 180.0)));

        northEastLongitude = centerLongitude + longitudeDegree; // 上
        southWestLongitude = centerLongitude - longitudeDegree; // 下

        returnList = {
            northEastLongitude: northEastLongitude,
            southWestLongitude: southWestLongitude
        };

        return returnList;
    }
};

window.distance = distance;
